import React from 'react';
import {
  MagnifyingGlassPlusIcon,
  MagnifyingGlassMinusIcon,
  ArrowPathIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@heroicons/react/24/outline';

interface PdfToolbarProps {
  currentPage: number;
  totalPages: number;
  scale: number;
  onPrevPage: () => void;
  onNextPage: () => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onResetZoom: () => void;
  onRotate: () => void;
}

const PdfToolbar: React.FC<PdfToolbarProps> = ({
  currentPage,
  totalPages,
  scale,
  onPrevPage,
  onNextPage,
  onZoomIn,
  onZoomOut,
  onResetZoom,
  onRotate,
}) => {
  return (
    <div className="flex items-center justify-between px-3 py-1.5 bg-gray-50 border-t border-gray-200">
      {/* Navigation pages */}
      <div className="flex items-center gap-1">
        <button
          onClick={onPrevPage}
          disabled={currentPage <= 1}
          className="p-1 rounded hover:bg-gray-200 disabled:opacity-30 disabled:cursor-not-allowed"
        >
          <ChevronLeftIcon className="w-4 h-4" />
        </button>
        <span className="text-xs text-gray-600 min-w-[60px] text-center">
          {currentPage} / {totalPages}
        </span>
        <button
          onClick={onNextPage}
          disabled={currentPage >= totalPages}
          className="p-1 rounded hover:bg-gray-200 disabled:opacity-30 disabled:cursor-not-allowed"
        >
          <ChevronRightIcon className="w-4 h-4" />
        </button>
      </div>

      {/* Zoom controls */}
      <div className="flex items-center gap-1">
        <button onClick={onZoomOut} className="p-1 rounded hover:bg-gray-200">
          <MagnifyingGlassMinusIcon className="w-4 h-4" />
        </button>
        <button
          onClick={onResetZoom}
          className="text-xs text-gray-600 px-1.5 py-0.5 rounded hover:bg-gray-200 min-w-[40px] text-center"
        >
          {Math.round(scale * 100)}%
        </button>
        <button onClick={onZoomIn} className="p-1 rounded hover:bg-gray-200">
          <MagnifyingGlassPlusIcon className="w-4 h-4" />
        </button>
        <div className="w-px h-4 bg-gray-300 mx-1" />
        <button onClick={onRotate} className="p-1 rounded hover:bg-gray-200">
          <ArrowPathIcon className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default PdfToolbar;
